<template>
  <button class="category-button shipping-to grid-x align-middle undecorated-link" tabindex="0" @click.prevent="openInternationalContextSlideout">
    <Flag class="margin-right-xs" width="21px" height="21px" />

    <span>Shipping To</span>
  </button>
</template>

<script setup>
import useInternationalSlideout from '~/composables/features/useInternationalSlideout';
import Flag from '~/components/common/Flag.common';
import { RESET_OVERLAY } from '#shared/types/actions';
import { useMobileNav } from '~/composables/useMobileNav';

const navOverlay = useNavOverlay();

const { isMenuOpened, wasSideNavVisibleRecently } = useMobileNav();
const { openInternationalSlideout } = useInternationalSlideout();

function openInternationalContextSlideout() {
  isMenuOpened.value = false;
  wasSideNavVisibleRecently.value = false;
  navOverlay?.[RESET_OVERLAY]();
  openInternationalSlideout();
}
</script>

<style lang="scss" brand="mcom" scoped>
.shipping-to {
  height: 24px;
}

.category-button {
  cursor: pointer;
  width: 100%;
}

span {
  margin-left: 3px;
}
</style>
